var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('Login',{attrs:{"email":_vm.username}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }